import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/core/user/user.model';
import { UserService } from 'app/core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
import { webpages_Role } from 'app/shared/models/domain/data.model';
import { environment } from 'environments/environment';
import { DashboardService } from 'app/modules/dashboard/dashboard.service';
import { CamelCaseToWordsPipe } from 'app/shared/pipes/camel-case-to-words.pipe';

@Component({
    selector: 'user-menu',
    templateUrl: './user-menu.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'userMenu'
})
export class UserMenuComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    roleString: string = '(unknown)';
    roles: any;
    selectedTab: string;
    tabs: string[];
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private dashboardService: DashboardService,
        private authService: AuthService,
        private camelPipe: CamelCaseToWordsPipe,
    ) {
    }

    ngOnInit(): void {
        if (this.authService.localUserRoles?.length) {
            this.tabs = [];
            this.roles = this.authService.localUserRoles;
            this.roleString = this.authService.localUserRoles.map(r => r.roleName).join(', ');
            this.authService.localUserRoles
                .forEach((role: webpages_Role) => {

                    Object.keys(environment.roleTabs)
                        .forEach((key) => {
                            if (environment.roleTabs[key].indexOf(role.roleName) > -1
                                && this.tabs.indexOf(this.camelPipe.transform(key)) == -1) {
                                this.tabs.push(this.camelPipe.transform(key));
                            }
                        });
                });

            if (isNaN(this.dashboardService.tabIndex)) {
                this.onChangeRole(0, false);
            } else {
                this.onChangeRole(this.dashboardService.tabIndex, false);
            }
        }
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    onChangeRole(idx: number, reload = false): any {
        this.dashboardService.tabIndex = idx;
        this.selectedTab = this.tabs[this.dashboardService.tabIndex];
        if (reload) {
            this._router.navigate(['/reload'], { replaceUrl: true }).then(() => {
                this._router.navigate(['/home'], { replaceUrl: true });
            });
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    updateUserStatus(status: string): void {
        if (!this.user) {
            return;
        }

        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }

    profile(): void {
        this._router.navigate(['/profile']);
    }

    changePassword(): void {
        this._router.navigate(['/change-password']);
    }

    users(): void {
        this._router.navigate(['/users']);
    }
}
